export interface CasinoBlockState {
	isCasinoBlocked?: boolean;
	isPlayerProfileSelected?: boolean;
	isSelectionPostponed?: boolean;
}

export interface CasinoBlockUpdate {
	isCasinoBlocked: boolean;
	isPlayerProfileSelected: boolean;
}

export const CASINO_CLASSIFICATIONS = [
	"Unclassified",
	"Bingo",
	"FixedOddsGames",
	"Scratch",
	"Slots",
	"TableGamesLIVE",
	"TableGamesRNG",
	"VideoPoker",
	"Poker",
	"CommonDraw",
	"LiveCasino",
];
